import $xhr from './xhr.js';

export default function AmiEEPROM(endPoint) {
    if(typeof endPoint !== 'string')
        throw 'endPoint must be a string';

    // when the pools rewrite happen, retrieve this from futami common
    const appId = '1';

    return {
        create: fileInput => {
            if(!(fileInput instanceof File))
                throw 'fileInput must be an instance of window.File';

            let userAborted = false;
            let abortHandler;

            return {
                abort: () => {
                    userAborted = true;
                    if(typeof abortHandler === 'function')
                        abortHandler();
                },
                start: async progress => {
                    if(userAborted)
                        throw 'File upload was cancelled by the user, it cannot be restarted.';

                    const reportProgress = typeof progress !== 'function' ? undefined : ev => {
                        progress({
                            loaded: ev.loaded,
                            total: ev.total,
                            progress: ev.total <= 0 ? 0 : ev.loaded / ev.total,
                        });
                    };

                    const formData = new FormData;
                    formData.append('src', appId);
                    formData.append('file', fileInput);

                    try {
                        const { status, body } = await $xhr.post(`${endPoint}/uploads`, {
                            authed: true,
                            type: 'json',
                            upload: reportProgress,
                            abort: handler => abortHandler = handler
                        }, formData);

                        if(body === null)
                            throw "The upload server didn't return the metadata for some reason.";

                        if(status !== 201)
                            throw body.english ?? body.error ?? `Upload failed with status code ${status}`;

                        body.isImage = () => body.type.indexOf('image/') === 0;
                        body.isVideo = () => body.type.indexOf('video/') === 0;
                        body.isAudio = () => body.type.indexOf('audio/') === 0;
                        body.isMedia = () => body.isImage() || body.isAudio() || body.isVideo();

                        return Object.freeze(body);
                    } catch(ex) {
                        if(userAborted)
                            throw '';

                        throw ex;
                    }
                },
            };
        },

        delete: async fileInfo => {
            if(typeof fileInfo !== 'object')
                throw 'fileInfo must be an object';
            if(typeof fileInfo.urlf !== 'string')
                throw 'fileInfo.urlf must be a string';

            const { status, body } = await $xhr.delete(fileInfo.urlf, { authed: true, type: 'json' });

            if(status !== 204) {
                if(body === null)
                    throw `Delete failed with status code ${status}`;

                throw body.english ?? body.error ?? `Delete failed with status code ${status}`;
            }
        },
    };
};
